import React, { Component, createRef } from "react";
import { isAdmin, isAccountant, isOperator } from "utils/helpers";
import SelectField from "components/EnhancedSelectField";
import MenuItem from "@mui/material/MenuItem";
import TextField from "components/EnhancedTextField";
import PhoneNumberInput from "components/PhoneNumberInput";
import { withStyles } from "@mui/styles";
import { connect } from "react-redux";
import { styles } from "../../../create-customer/styles";
import ReeValidate from "ree-validate";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { Checkbox, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import { DEFAULT_COUNTRY, CASHBOX_PAYMENT_TYPES } from "constants/Data";
import * as settingService from "services/settingService";
import SelectReceiverSender from "components/FormComponents";
import * as cashboxServiceV2 from "services/cashboxServiceV2";
import moment from "moment";
import DateField from "@mui/material/TextField";


class CashboxSetupV2 extends Component {
  constructor(props) {
    super(props);
    this.dateInputRef = createRef();
    this.validator = new ReeValidate({});

    this.state = {
      errors: this.validator.errors,
      cashboxSettingId: null,
      cashboxFrequency: null,
      notes: "",
      contactName: "",
      locationId: "",
      locationName: "",
      receiver_location: "",
      auditingDays: 3,
      officeId: 1,
      cashboxPhoneNumber: "",
      cashboxEmail: "",
      selectedWeekDays: null,
      offices: [],
      selectedDate: null,
      officialInvoice: false,
      createUponClientRequest: false,
      deductFromNextCashbox: false,
      paySeparately: false,
      isEditMode: false,
      cashboxDetails: [],
      members: [],
      selectedDates: [],
      showDatePicker: false,
      paymentMethod: 1,
      selfPickup: false,
    };
  }

  componentDidMount() {
    this.loadOffices();
    if (this.props.isEditMode) {
      this.setState({ cashboxLoading: true });
      this.fetchCashboxDetails(this.props.customerId);
    }
  }
  loadOffices() {
    this.setState((state) => ({ isLoading: true }));
    this.props
      .dispatch(settingService.fetchOffices())
      .then((response) => {
        this.setState({ offices: response.data || [] });
        const responseError = {
          isError: false,
          code: "",
          text: "",
        };
        this.setState((state) => ({ isLoading: false, responseError }));
      })
      .catch(({ error, statusCode }) => {
        const responseError = {
          isError: true,
          code: statusCode,
          text: error,
        };
        this.setState((state) => ({ isLoading: false, responseError }));
      });
  }

  fetchCashboxDetails = (cashboxId) => {
    this.props
      .dispatch(cashboxServiceV2.fetchCashboxDetails(cashboxId))
      .then((data) => {
        const { cashbox } = data;
        if (cashbox) {
          let parsedDates = [];
          try {
            if (data.cashboxSelectedDates) {
              if (typeof data.cashboxSelectedDates === 'string') {
                parsedDates = JSON.parse(data.cashboxSelectedDates);
              } else {
                parsedDates = data.cashboxSelectedDates;
              }
            }
          } catch (error) {
            console.error("Error parsing dates:", error);
            parsedDates = [];
          }
  
          this.setState({
            cashboxSettingId: cashbox.id,
            cashboxFrequency: cashbox.frequency === 6 || cashbox.frequency === 7 || cashbox.frequency === 8 ? 9 : cashbox.frequency,
            notes: cashbox.notes,
            contactName: cashbox.contact_name,
            locationId: cashbox.location_id,
            auditingDays: cashbox.auditing_days,
            officeId: cashbox.office_id,
            cashboxPhoneNumber: cashbox.phone_number,
            cashboxEmail: cashbox.email,
            selectedWeekDays: cashbox.cashbox_weekdays ? JSON.parse(cashbox.cashbox_weekdays) : [],
            selectedDate: data.cashboxMonthlyDate ? new Date(data.cashboxMonthlyDate) : null,
            selectedDates: parsedDates,
            officialInvoice: cashbox.official_invoice,
            createUponClientRequest: cashbox.create_upon_client_request,
            paymentMethod: cashbox.payment_method || 1,
            selfPickup: !!cashbox.self_pickup,
            deductFromNextCashbox: cashbox.deducted_payment,
            paySeparately: cashbox.separate_payment,
            isEditMode: true,
            receiver_location: data.location_name,
            members: data.memberNames,
            cashboxLoading: false,
          });
        } else {
          this.setState({
            members: data.memberNames,
            cashboxLoading: false,
          });
        }
      })
      .catch(({ error, statusCode }) => {
        const responseError = {
          isError: true,
          code: statusCode,
          text: error,
        };
        this.setState({
          responseError,
          cashboxLoading: false,
        });
      });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  handleCheck = (event, isInputChecked, name) => {
    if (name === "officialInvoice") {
      this.setState({
        [name]: isInputChecked,
        deductFromNextCashbox: false,
        paySeparately: true,
      });
    } else {
      if (name === "deductFromNextCashbox" || name === "paySeparately") {
        this.setState({ deductFromNextCashbox: !this.state.deductFromNextCashbox,
          paySeparately: !this.state.paySeparately,
         });
      } else {
        this.setState({ [name]: isInputChecked });
      }
    }
  };

  handleAddValidationErrorChange = (name, value) => {
    if (value) {
      this.state.errors.add({
        field: name,
        msg: value,
      });
    } else {
      this.state.errors.remove(name);
    }
  };
  handleSelectChange = (value, name) => {
    let maxSelection = 0;
    if (name === "cashboxFrequency") {
      this.setState({ selectedWeekDays: [] });
    } else if (name === "selectedWeekDays") {
      if (this.state.cashboxFrequency === 1) maxSelection = 0;
      if (
        this.state.cashboxFrequency === 2 ||
        this.state.cashboxFrequency === 5 ||
        this.state.cashboxFrequency === 9
      )
        maxSelection = 1;
      if (this.state.cashboxFrequency === 3) maxSelection = 2;
      if (this.state.cashboxFrequency === 4) maxSelection = 3;
      if (value.length > maxSelection) {
        value = value.slice(0, maxSelection);
      }
    }
    this.setState({ [name]: value });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    
    // Prevent negative values for auditingDays
    if (name === 'auditingDays') {
      const numValue = parseInt(value, 10);
      if (value !== '' && (isNaN(numValue) || numValue < 0)) {
        return; // Don't update state if value is negative
      }
    }
    
    this.setState({
      [name]: value,
    });
  };

  openDatePicker = () => {
    this.setState({ showDatePicker: true });
  };

  closeDatePicker = () => {
    this.setState({ showDatePicker: false });
  };

  handleOfficeChange = (event) => {
    this.setState({
      officeId: event.target.value,
    });
  };
  handleContactChange = (event) => {
    this.setState({
      contactName: event.target.value,
    });
  };
  handleDateChange = (date) => {
    this.setState((prevState) => {
      let newSelectedDates = [...prevState.selectedDates];
      if (newSelectedDates.length < 3) {
        newSelectedDates.push(moment(date).format("YYYY-MM-DD"));
      } else {
        newSelectedDates.shift();
        newSelectedDates.push(moment(date).format("YYYY-MM-DD"));
      }
      newSelectedDates.sort();
      return {
        selectedDates: newSelectedDates,
        selectedDate: newSelectedDates[0],
        showDatePicker: false,
      };
    });
  };
  toggleDatePicker = () => {
    this.setState((prevState) => ({
      showDatePicker: !prevState.showDatePicker,
    }));
  };
  handleRemoveDate = (indexToRemove) => {
    this.setState((prevState) => {
      const newSelectedDates = prevState.selectedDates.filter(
        (_, index) => index !== indexToRemove,
      );
      return {
        selectedDates: newSelectedDates,
        selectedDate: newSelectedDates[0] || null,
      };
    });
  };
  getFrequencyText = () => {
    // Monthly frequencies are no longer supported in v2
    return "Select Frequency";
  };
  getFrequencyId = () => {
    // Monthly frequencies are no longer supported in v2
    return this.state.cashboxFrequency;
  };
  render() {
    const { errors } = this.state;
    const { user, classes, isEditMode, is_onboarding } = this.props;
    const validationErrors = this.props.errors || errors;
    const renderFrequencyField =
      false ? (
        <div className="col-md-8">
          <div style={{ position: "relative" }}>
            <div
              style={{
                padding: "8px",
                minHeight: "48px",
                cursor: "pointer",
                marginTop: "28px",
              }}
              onClick={this.toggleDatePicker}
            >
              <div
                style={{
                  color: "#666",
                  position: "absolute",
                  top: "-20px",
                  fontSize: "12px",
                }}
              >
                Select Dates (Max 3)
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                {this.state.selectedDates.map((date, index) => (
                  <div
                    key={index}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: "#f5f5f5",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      flexShrink: 0,
                    }}
                  >
                    <span>{date}</span>
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleRemoveDate(index);
                      }}
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer",
                        color: "#666",
                      }}
                    >
                      ×
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <IconButton
              sx={{
                position: "absolute",
                right: "250px",
                top: "-32px",
                cursor: "pointer",
                color: "#ffc107",
                "&:Disabled": { color: "grey !important" },
              }}
              onClick={this.openDatePicker}
              disabled={this.state.selectedDates.length >= 3}
            >
              <i className="material-icons">add_circle</i>
            </IconButton>
            <MobileDatePicker
              open={this.state.showDatePicker}
              onClose={this.closeDatePicker}
              ref={this.dateInputRef}
              onChange={this.handleDateChange}
              renderInput={(params) => <DateField {...params} sx={{ display: "none" }} />}
            />
          </div>
          {this.state.showDatePicker && (
            <div
              style={{
                position: "absolute",
                zIndex: 1000,
                backgroundColor: "white",
                boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                borderRadius: "4px",
              }}
            ></div>
          )}
        </div>
      ) : (
        <div className="col-md-4">
          <SelectField
            floatingLabelText="Scheduled Days*"
            multiple={true}
            value={this.state.selectedWeekDays}
            onChange={(event) =>
              this.handleSelectChange(event.target.value, "selectedWeekDays")
            }
            fullWidth={true}
            disabled={
              !this.state.cashboxFrequency || this.state.cashboxFrequency === 1 || (isOperator(user) && isEditMode && !is_onboarding)
            }
            errorText={
              validationErrors.has("selectedWeekDays") && validationErrors.first("selectedWeekDays")
            }
          >
            <MenuItem value={1} >Monday</MenuItem>
            <MenuItem value={2} >Tuesday</MenuItem>
            <MenuItem value={3} >Wednesday</MenuItem>
            <MenuItem value={4} >Thursday</MenuItem>
            {DEFAULT_COUNTRY !== 101 && (
              <MenuItem value={5} >Friday</MenuItem>
            )}
            <MenuItem value={6} >Saturday</MenuItem>
            {DEFAULT_COUNTRY === 101 && (
              <MenuItem value={7} >Sunday</MenuItem>
            )}
          </SelectField>
        </div>
      );
      if (this.props.onCreate) {
        const { offices, ...stateWithoutOfficesAndCurrencies } = this.state;
        // Add version parameter for v2
        stateWithoutOfficesAndCurrencies.version = "v2";
        this.props.onCreate(stateWithoutOfficesAndCurrencies);
      }
    return (
      <div className="row">
        <div className="col-md-12">
          <h4 style={{ fontWeight: "bold" }}>Cashbox Settings</h4>
        </div>
        <div className="col-md-4">
          <SelectField
            floatingLabelText="Cashbox Frequency*"
            value={this.state.cashboxFrequency}
            onChange={(event) =>
              this.handleSelectChange(event.target.value, "cashboxFrequency")
            }
            disabled={isOperator(user) && isEditMode && !is_onboarding}
            fullWidth={true}
            style={{ marginRight: "10px" }}
            errorText={
              validationErrors.has("cashboxFrequency") && validationErrors.first("cashboxFrequency")
            }
          >
            <MenuItem value={9} >Once every four weeks</MenuItem>
            <MenuItem value={5} >Once every two weeks</MenuItem>
            <MenuItem value={2} >Once a week</MenuItem>
            {(isAdmin(user) || isAccountant(user) || isOperator(user)) && (
              <MenuItem value={3} >Twice a week</MenuItem>
            )}
            {(isAdmin(user) || isAccountant(user) || isOperator(user)) && (
              <MenuItem value={4} >Three times a week</MenuItem>
            )}
            {(isAdmin(user) || isAccountant(user) || isOperator(user)) && (
              <MenuItem value={1} >Daily</MenuItem>
            )}
          </SelectField>
        </div>

        {renderFrequencyField}
        {isEditMode && (
          <React.Fragment>
            <div className="col-md-4">
              <SelectField
                name="contactName"
                fullWidth={true}
                floatingLabelText="Contact Name *"
                value={this.state.contactName}
                onChange={this.handleContactChange}
                disabled={isOperator(user) && isEditMode && !is_onboarding}
                errorText={
                  validationErrors.has("contactName") && validationErrors.first("contactName")
                }
              >
                {this.state.members && this.state.members.map((member, index) => (
                  <MenuItem key={index} value={member}>{member}</MenuItem>
                ))}
              </SelectField>
            </div>
            <div className="col-md-4">
              <SelectReceiverSender
                name={"receiver_location"}
                name_id={"locationId"}
                value_id={this.state.locationId}
                value={this.state.receiver_location}
                attribute={"full_location"}
                label={"Location"}
                handleChange={this.handleChange}
                errors={validationErrors}
                customer_id={this.props.customerId}
                disabled={isOperator(user) && isEditMode && !is_onboarding}
              />
            </div>
            <div className="col-md-4">
              <SelectField
                name="officeId"
                floatingLabelText="Wakilni Branch *"
                value={this.state.officeId}
                onChange={this.handleOfficeChange}
                fullWidth={true}
                disabled={true}
                errorText={
                  validationErrors.has("officeId") && validationErrors.first("officeId")
                }
              >
                {this.state.offices &&
                  this.state.offices.map((office) => (
                    <MenuItem
                      key={office.id}
                      value={office.id}
                    >{office.office_name}</MenuItem>
                  ))}
              </SelectField>
            </div>
            <div className="col-md-4">
              <PhoneNumberInput
                name="cashboxPhoneNumber"
                label_text="Phone Number *"
                value={this.state.cashboxPhoneNumber}
                handleChange={this.handleChange}
                handleAddValidationErrorChange={
                  this.handleAddValidationErrorChange
                }
                disabled={isOperator(user) && isEditMode && !is_onboarding}
                errorText={
                  validationErrors.has("cashboxPhoneNumber") && validationErrors.first("cashboxPhoneNumber")
                }
              />
            </div>
            <div className="col-md-4">
              <TextField
                name="cashboxEmail"
                floatingLabelText="Email *"
                fullWidth={true}
                value={this.state.cashboxEmail}
                onChange={this.handleInputChange}
                disabled={isOperator(user) && isEditMode && !is_onboarding}
                errorText={
                  validationErrors.has("cashboxEmail") && validationErrors.first("cashboxEmail")
                }
              />
            </div>
          </React.Fragment>
        )}

        <div className="col-md-4">
          <TextField
            name="notes"
            floatingLabelText="Notes"
            fullWidth={true}
            value={this.state.notes}
            onChange={this.handleInputChange}
            disabled={isOperator(user) && isEditMode && !is_onboarding}
          />
        </div>
        <div className="col-md-4">
          <TextField
            name="auditingDays"
            floatingLabelText="Auditing Days *"
            fullWidth={true}
            type="number"
            value={this.state.auditingDays}
            onChange={this.handleInputChange}
            disabled={isOperator(user) && isEditMode && !is_onboarding}
            errorText={
              validationErrors.has("auditingDays") && validationErrors.first("auditingDays")
            }
            inputProps={{
              min: 0,
              step: 1
            }}
          />
        </div>
        <div className="col-md-4">
          <SelectField
            floatingLabelText="Cashbox Payment Type"
            value={this.state.paymentMethod}
            onChange={(event) => {
              const value = event.target.value;
              this.handleSelectChange(value, "paymentMethod");
              if (parseInt(value) !== 1) {
                this.setState({ selfPickup: false });
              }
            }}
            fullWidth={true}
            disabled={isOperator(user) && isEditMode && !is_onboarding}
          >
            {CASHBOX_PAYMENT_TYPES.map((method) => (
              <MenuItem key={method.id} value={method.id}>{method.label}</MenuItem>
            ))}
          </SelectField>
        </div>
        {parseInt(this.state.paymentMethod) === 1 && (
        <div className="col-md-4" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "8px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.selfPickup}
                onChange={(event, checked) =>
                  this.handleCheck(event, checked, "selfPickup")
                }
                disabled={isOperator(user) && isEditMode && !is_onboarding}
              />
            }
            componentsProps={{
              typography: { fontWeight: "bold", fontSize: "14px !important" },
            }}
            label="Self Pickup"
          />
        </div>
        )}
        <div className="col-md-12"></div>
        <div className="col-md-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.officialInvoice}
                onChange={(event, checked) =>
                  this.handleCheck(event, checked, "officialInvoice")
                }
                disabled={isOperator(user) && isEditMode && !is_onboarding}
              />
            }
            componentsProps={{
              typography: { fontWeight: "bold", fontSize: "14px !important" },
            }}
            label="Monthly Official Invoice"
          />
        </div>
        <div className="col-md-4">
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.createUponClientRequest}
                onChange={(event, checked) =>
                  this.handleCheck(event, checked, "createUponClientRequest")
                }
                disabled={isOperator(user) && isEditMode && !is_onboarding}
              />
            }
            componentsProps={{
              typography: { fontWeight: "bold", fontSize: "14px !important" },
            }}
            label="Create Upon Client Request"
          />
        </div>
        <div
          className="col-md-12"
          style={{ marginTop: "0%" }}
        >
          {this.state.officialInvoice ? (
            <div style={{ marginLeft: isEditMode ? "11%" : "4%" }}>
              <p
                style={{
                  marginLeft: "1%",
                  fontSize: "smaller",
                  fontStyle: "italic",
                  color: "grey",
                }}
              >
                Make sure that the MOF Field is filled
              </p>
              <RadioGroup
                name="deductOrPay"
                defaultValue={
                  this.state.deductFromNextCashbox ? "deduct" : "pay"
                }
                value={this.state.deductFromNextCashbox ? "deduct" : "pay"}
                onChange={(event, newValue) => {
                  if (newValue === "deduct") {
                    this.handleCheck(event, true, "deductFromNextCashbox");
                  } else {
                    this.handleCheck(event, true, "paySeparately");
                  }
                }}
              >
                <FormControlLabel
                  label="Deducted from the next Cashbox"
                  value="deduct"
                  control={<Radio disabled={isOperator(user) && isEditMode && !is_onboarding} />}
                  componentsProps={{
                    typography: { fontSize: "14px !important" },
                  }}
                />
                <FormControlLabel label="Paid Separately" value="pay" control={<Radio disabled={isOperator(user) && isEditMode && !is_onboarding} />} sx={{ marginTop: "-10px" }} componentsProps={{typography: { fontSize: "14px !important" }}}/>
              </RadioGroup>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
CashboxSetupV2.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    officeList: state.settings.officeList,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(CashboxSetupV2));

